import { NgModule } from '@angular/core';

import { ChartComponent } from './chart';

@NgModule({
    declarations: [ChartComponent],
    exports: [ChartComponent],
})
export class ChartModule {}
